import { t } from 'i18next';

const getLastStepButtonText = (isAISiteWizardEnabled) =>
  isAISiteWizardEnabled ? t('Create website') : t('Finish setup');

export default getLastStepButtonText;
